const styles = {
  modal: (theme) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: "450px",
    bgcolor: 'background.paper',
    border: '1px solid #E9EBEC',
    borderRadius: "4px",
    boxShadow: 24,
    padding: "15px 30px",
    [theme.breakpoints.down("sm")]: {
      width: "380px",
    },
  }),

  modalCloseIcon: (theme) => ({
    display: "flex",
    justifyContent: "flex-end",
    paddingBottom: "5px",
  }),

  modalHead: (theme) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "5px",
  }),

  modalFlexBox: (theme) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    // gap: 2,
  }),

  typTitle: (theme) => ({
    fontSize: "20px"
  }),

  modalFieldBox: (theme) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  }),

  modalTextField: (theme) => ({
    width: "289px",
  }),

  modalBtn: (theme) => ({
    padding: "10px 50px",
    borderRadius:"8px"
  })
}

export default styles;